export interface ConversionEventOptions {
  valueCents?: number;
  valueCurrency?: string;
  userGuid?: string;
  eventId?: string;
}

export enum ConversionEvent {
  CONFIRMED_REGISTRATION = 'CompleteRegistration',
  SURVEY_COMPLETE = 'SurveyComplete',
  SURVEY_OPT_IN = 'SurveyOptIn',
  LOGIN = 'Login',
  LOGOUT = 'Logout',
}

function handleGTMEvent(event: ConversionEvent, options: ConversionEventOptions) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event,
    ...options,
  });
}

export function handleConversionEvent(eventName: ConversionEvent, options: ConversionEventOptions) {
  handleGTMEvent(eventName, options);
}
